export const stripeCurrencies = [
    { name: "AED", value: "AED" }, // United Arab Emirates Dirham
    { name: "AFN", value: "AFN" }, // Afghan Afghani
    { name: "ALL", value: "ALL" }, // Albanian Lek
    { name: "AMD", value: "AMD" }, // Armenian Dram
    { name: "ANG", value: "ANG" }, // Netherlands Antillean Guilder
    { name: "AOA", value: "AOA" }, // Angolan Kwanza
    { name: "ARS", value: "ARS" }, // Argentine Peso
    { name: "AUD", value: "AUD" }, // Australian Dollar
    { name: "AWG", value: "AWG" }, // Aruban Florin
    { name: "AZN", value: "AZN" }, // Azerbaijani Manat
    { name: "BAM", value: "BAM" }, // Bosnia-Herzegovina Convertible Mark
    { name: "BBD", value: "BBD" }, // Barbadian Dollar
    { name: "BDT", value: "BDT" }, // Bangladeshi Taka
    { name: "BGN", value: "BGN" }, // Bulgarian Lev
    { name: "BHD", value: "BHD" }, // Bahraini Dinar
    { name: "BIF", value: "BIF" }, // Burundian Franc
    { name: "BMD", value: "BMD" }, // Bermudian Dollar
    { name: "BND", value: "BND" }, // Brunei Dollar
    { name: "BOB", value: "BOB" }, // Bolivian Boliviano
    { name: "BRL", value: "BRL" }, // Brazilian Real
    { name: "BSD", value: "BSD" }, // Bahamian Dollar
    { name: "BTN", value: "BTN" }, // Bhutanese Ngultrum
    { name: "BWP", value: "BWP" }, // Botswanan Pula
    { name: "BYN", value: "BYN" }, // Belarusian Ruble
    { name: "BZD", value: "BZD" }, // Belize Dollar
    { name: "CAD", value: "CAD" }, // Canadian Dollar
    { name: "CDF", value: "CDF" }, // Congolese Franc
    { name: "CHF", value: "CHF" }, // Swiss Franc
    { name: "CLP", value: "CLP" }, // Chilean Peso
    { name: "CNY", value: "CNY" }, // Chinese Yuan
    { name: "COP", value: "COP" }, // Colombian Peso
    { name: "CRC", value: "CRC" }, // Costa Rican Colón
    { name: "CUP", value: "CUP" }, // Cuban Peso
    { name: "CVE", value: "CVE" }, // Cape Verdean Escudo
    { name: "CZK", value: "CZK" }, // Czech Koruna
    { name: "DJF", value: "DJF" }, // Djiboutian Franc
    { name: "DKK", value: "DKK" }, // Danish Krone
    { name: "DOP", value: "DOP" }, // Dominican Peso
    { name: "DZD", value: "DZD" }, // Algerian Dinar
    { name: "EGP", value: "EGP" }, // Egyptian Pound
    { name: "ERN", value: "ERN" }, // Eritrean Nakfa
    { name: "ETB", value: "ETB" }, // Ethiopian Birr
    { name: "EUR", value: "EUR" }, // Euro
    { name: "FJD", value: "FJD" }, // Fijian Dollar
    { name: "FKP", value: "FKP" }, // Falkland Islands Pound
    { name: "FOK", value: "FOK" }, // Faroese Króna
    { name: "GBP", value: "GBP" }, // British Pound Sterling
    { name: "GEL", value: "GEL" }, // Georgian Lari
    { name: "GGP", value: "GGP" }, // Guernsey Pound
    { name: "GHS", value: "GHS" }, // Ghanaian Cedi
    { name: "GIP", value: "GIP" }, // Gibraltar Pound
    { name: "GMD", value: "GMD" }, // Gambian Dalasi
    { name: "GNF", value: "GNF" }, // Guinean Franc
    { name: "GTQ", value: "GTQ" }, // Guatemalan Quetzal
    { name: "GYD", value: "GYD" }, // Guyanaese Dollar
    { name: "HKD", value: "HKD" }, // Hong Kong Dollar
    { name: "HNL", value: "HNL" }, // Honduran Lempira
    { name: "HRK", value: "HRK" }, // Croatian Kuna
    { name: "HTG", value: "HTG" }, // Haitian Gourde
    { name: "HUF", value: "HUF" }, // Hungarian Forint
    { name: "IDR", value: "IDR" }, // Indonesian Rupiah
    { name: "ILS", value: "ILS" }, // Israeli New Shekel
    { name: "IMP", value: "IMP" }, // Isle of Man Pound
    { name: "INR", value: "INR" }, // Indian Rupee
    { name: "IQD", value: "IQD" }, // Iraqi Dinar
    { name: "IRR", value: "IRR" }, // Iranian Rial
    { name: "ISK", value: "ISK" }, // Icelandic Króna
    { name: "JEP", value: "JEP" }, // Jersey Pound
    { name: "JMD", value: "JMD" }, // Jamaican Dollar
    { name: "JOD", value: "JOD" }, // Jordanian Dinar
    { name: "JPY", value: "JPY" }, // Japanese Yen
    { name: "KES", value: "KES" }, // Kenyan Shilling
    { name: "KGS", value: "KGS" }, // Kyrgyzstani Som
    { name: "KHR", value: "KHR" }, // Cambodian Riel
    { name: "KID", value: "KID" }, // Kiribati Dollar
    { name: "KMF", value: "KMF" }, // Comorian Franc
    { name: "KRW", value: "KRW" }, // South Korean Won
    { name: "KWD", value: "KWD" }, // Kuwaiti Dinar
    { name: "KYD", value: "KYD" }, // Cayman Islands Dollar
    { name: "KZT", value: "KZT" }, // Kazakhstani Tenge
    { name: "LAK", value: "LAK" }, // Laotian Kip
    { name: "LBP", value: "LBP" }, // Lebanese Pound
    { name: "LKR", value: "LKR" }, // Sri Lankan Rupee
    { name: "LRD", value: "LRD" }, // Liberian Dollar
    { name: "LSL", value: "LSL" }, // Lesotho Loti
    { name: "LYD", value: "LYD" }, // Libyan Dinar
    { name: "MAD", value: "MAD" }, // Moroccan Dirham
    { name: "MDL", value: "MDL" }, // Moldovan Leu
    { name: "MGA", value: "MGA" }, // Malagasy Ariary
    { name: "MKD", value: "MKD" }, // Macedonian Denar
    { name: "MMK", value: "MMK" }, // Myanmar Kyat
    { name: "MNT", value: "MNT" }, // Mongolian Tugrik
    { name: "MOP", value: "MOP" }, // Macanese Pataca
    { name: "MRU", value: "MRU" }, // Mauritanian Ouguiya
    { name: "MUR", value: "MUR" }, // Mauritian Rupee
    { name: "MVR", value: "MVR" }, // Maldivian Rufiyaa
    { name: "MWK", value: "MWK" }, // Malawian Kwacha
    { name: "MXN", value: "MXN" }, // Mexican Peso
    { name: "MYR", value: "MYR" }, // Malaysian Ringgit
    { name: "MZN", value: "MZN" }, // Mozambican Metical
    { name: "NAD", value: "NAD" }, // Namibian Dollar
    { name: "NGN", value: "NGN" }, // Nigerian Naira
    { name: "NIO", value: "NIO" }, // Nicaraguan Córdoba
    { name: "NOK", value: "NOK" }, // Norwegian Krone
    { name: "NPR", value: "NPR" }, // Nepalese Rupee
    { name: "NZD", value: "NZD" }, // New Zealand Dollar
    { name: "OMR", value: "OMR" }, // Omani Rial
    { name: "PAB", value: "PAB" }, // Panamanian Balboa
    { name: "PEN", value: "PEN" }, // Peruvian Sol
    { name: "PGK", value: "PGK" }, // Papua New Guinean Kina
    { name: "PHP", value: "PHP" }, // Philippine Peso
    { name: "PKR", value: "PKR" }, // Pakistani Rupee
    { name: "PLN", value: "PLN" }, // Polish Zloty
    { name: "PYG", value: "PYG" }, // Paraguayan Guarani
    { name: "QAR", value: "QAR" }, // Qatari Rial
    { name: "RON", value: "RON" }, // Romanian Leu
    { name: "RSD", value: "RSD" }, // Serbian Dinar
    { name: "RUB", value: "RUB" }, // Russian Ruble
    { name: "RWF", value: "RWF" }, // Rwandan Franc
    { name: "SAR", value: "SAR" }, // Saudi Riyal
    { name: "SBD", value: "SBD" }, // Solomon Islands Dollar
    { name: "SCR", value: "SCR" }, // Seychellois Rupee
    { name: "SDG", value: "SDG" }, // Sudanese Pound
    { name: "SEK", value: "SEK" }, // Swedish Krona
    { name: "SGD", value: "SGD" }, // Singapore Dollar
    { name: "SHP", value: "SHP" }, // Saint Helena Pound
    { name: "SLE", value: "SLE" }, // Sierra Leonean Leone
    { name: "SOS", value: "SOS" }, // Somali Shilling
    { name: "SRD", value: "SRD" }, // Surinamese Dollar
    { name: "SSP", value: "SSP" }, // South Sudanese Pound
    { name: "STN", value: "STN" }, // São Tomé and Príncipe Dobra
    { name: "SYP", value: "SYP" }, // Syrian Pound
    { name: "SZL", value: "SZL" }, // Swazi Lilangeni
    { name: "THB", value: "THB" }, // Thai Baht
    { name: "TJS", value: "TJS" }, // Tajikistani Somoni
    { name: "TMT", value: "TMT" }, // Turkmenistani Manat
    { name: "TND", value: "TND" }, // Tunisian Dinar
    { name: "TOP", value: "TOP" }, // Tongan Paʻanga
    { name: "TRY", value: "TRY" }, // Turkish Lira
    { name: "TTD", value: "TTD" }, // Trinidad and Tobago Dollar
    { name: "TVD", value: "TVD" }, // Tuvaluan Dollar
    { name: "TWD", value: "TWD" }, // New Taiwan Dollar
    { name: "TZS", value: "TZS" }, // Tanzanian Shilling
    { name: "UAH", value: "UAH" }, // Ukrainian Hryvnia
    { name: "UGX", value: "UGX" }, // Ugandan Shilling
    { name: "USD", value: "USD" }, // United States Dollar
    { name: "UYU", value: "UYU" }, // Uruguayan Peso
    { name: "UZS", value: "UZS" }, // Uzbekistani Som
    { name: "VES", value: "VES" }, // Venezuelan Bolívar
    { name: "VND", value: "VND" }, // Vietnamese Dong
    { name: "VUV", value: "VUV" }, // Vanuatu Vatu
    { name: "WST", value: "WST" }, // Samoan Tala
    { name: "XAF", value: "XAF" }, // Central African CFA Franc
    { name: "XCD", value: "XCD" }, // East Caribbean Dollar
    { name: "XOF", value: "XOF" }, // West African CFA Franc
    { name: "XPF", value: "XPF" }, // CFP Franc
    { name: "YER", value: "YER" }, // Yemeni Rial
    { name: "ZAR", value: "ZAR" }, // South African Rand
    { name: "ZMW", value: "ZMW" }, // Zambian Kwacha
];